// reducers/schoolAppointmentReducer.js
import {
    SCHOOL_CREATE_APPOINTMENT_REQUEST,
    SCHOOL_CREATE_APPOINTMENT_SUCCESS,
    SCHOOL_RESET_APPOINTMENT_STATE,
  } from '../actions/schoolAppointmentTypes';
  
  const initialState = {
    schoolAppointment: [], // Store appointments as an array
  };
  
  const schoolAppointmentReducer = (state = initialState, action) => {
    switch (action.type) {
      case SCHOOL_CREATE_APPOINTMENT_REQUEST:
        return {
          ...state,
        };
      case SCHOOL_CREATE_APPOINTMENT_SUCCESS:
        return {
          ...state,
          schoolAppointment: [...state.schoolAppointment, action.payload], // Append payload
        };
      case SCHOOL_RESET_APPOINTMENT_STATE:
        return initialState;
      default:
        return state;
    }
  };
  
  export default schoolAppointmentReducer;